// 表格列定义
export const tableColumns = [
    {
      key: 'wayCode',
      title: '通道ID',
      width: 260,
      dataIndex: 'wayCode',
      align: 'center'
    //   scopedSlots: { customRender: 'channelIdSlot' }
    },
    {
      key: 'wayName',
      title: '通道名称',
      width: 150,
      align: 'center',
    //   dataIndex: 'wayName'
      scopedSlots: { customRender: 'channelNameSlot' }
    },
    // {
    //   key: 'rate',
    //   title: '商户费率',
    //   width: 100,
    //   scopedSlots: { customRender: 'rateSlot' }
    // },
    {
      key: 'fixedFeeAmount',
      title: '手续费',
      width: 180,
      align: 'center',
      scopedSlots: { customRender: 'fixedFeeAmountSlot' }
    },
    {
      key: 'minOrderAmount',
      title: '单笔最小',
      width: 120,
      align: 'center',
      scopedSlots: { customRender: 'minOrderAmountSlot' }
    },
    {
      key: 'maxOrderAmount',
      title: '单笔最大',
      width: 120,
      align: 'center',
      scopedSlots: { customRender: 'maxOrderAmountSlot' }
    },
    {
      key: 'singleAccountPayLimit',
      title: '账户24小时最大代付金额累计限制',
      // title: (
      //   <a-tooltip placement="top" title="这里是提示内容">
      //     <span>账户24小时最大代付金额累计限制 <a-icon type="question-circle" /></span>
      //   </a-tooltip>
      // ),
      width: 260,
      align: 'center',
      // slots: {
      //   title: 'singleAccountPayLimitTitle' // 定义slot名称
      // },
      scopedSlots: { customRender: 'singleAccountPayLimitSlot' }
    },
    {
      key: 'state',
      title: '状态',
      width: 100,
      align: 'center',
      scopedSlots: { customRender: 'stateSlot' }
    },
    {
        key: 'payType',
        title: '类型',
        width: 100,
        align: 'center',
        scopedSlots: { customRender: 'payTypeSlot' }
    }
  ]
